(function () {

    // Find all the validation requirements and instantiate a new validation set.
    const passwordRequirementRules = $('li[data-requirement-pattern]'),
        ruleSets = {};

    for (let i = 0; i < passwordRequirementRules.length; i++) {

        // Extract validation information from each of the validation rules.
        var $ruleTargetEle = $(passwordRequirementRules[i]),
            validationTarget = $ruleTargetEle.data('requirement-target'),
            validationPattern = $ruleTargetEle.data('requirement-pattern');

        // Create a new ruleset.
        var validationRuleset = {
            rule: validationPattern,
            target: $ruleTargetEle
        };

        // Initalise a new ruleset if one doesn't already exist for the same target input.
        ruleSets[validationTarget] = ruleSets[validationTarget] || [];

        // Append the new pattern rule to the array.
        ruleSets[validationTarget].push(validationRuleset);

    }

    for (let ruleSet in ruleSets) {

        // Find the input element to be validated.
        const $target = $('#' + ruleSet);

        // When the user has entered a value into the input, check the current value against the list of requirements.
        $target.on('keyup', function () {
            checkRequirements($target, ruleSets[ruleSet]);
        });

    }

    function checkRequirements(source, rules) {

        // Check each of the patterns against the current value of the form input.
        for (var i = 0; i < rules.length; i++) {
            checkRequirement(source, rules[i]);
        }

    }

    function checkRequirement(source, { rule, target }) {

        // Create a new regular expression object.
        const regexRule = new RegExp(rule);

        // Validate the input against the rule.
        const isValid = regexRule.test(source.val());

        // Updated the CSS class depending on the result of the validation.
        if (isValid) {
            target.removeClass('text-danger').addClass('text-success');
        } else {
            target.removeClass('text-success').addClass('text-danger');
        }

    }

})();